import React, { useCallback, useState } from "react";
import { LabeledIconInput, colors, DollarIcon } from "@commonsku/styles";
import { FilterMainComponentProps } from "../Filter";
import { isNull } from "lodash";

const MoneyInput = ({
  values,
  onChange,
  placeholder = "0",
  onKeyPress,
}: FilterMainComponentProps) => {
  const [error, setError] = useState(false);

  const isValid = useCallback((value) => {
    if (isNull(value) || value === '' || value.trim() === '') {
      return true;
    }
    const floatValue = parseFloat(value);
    if (isNaN(floatValue) || !isFinite(floatValue)) {
      return false;
    }

    if (floatValue < 0) {
      return false;
    }

    return /^\d*\.?\d*$/.test(value.trim());
  }, []);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isValid(e.target.value)) {
        setError(true);
        return;
      }

      setError(false);
      onChange(e.target.value);
  };

  return <LabeledIconInput
    Icon={<DollarIcon />}
    iconColor={colors.neutrals["60"]}
    value={values as number}
    error={error}
    placeholder={placeholder}
    onChange={handleOnChange}
    onKeyDown={onKeyPress}
  />;
};

export default MoneyInput;
